module.exports = __webpack_public_path__ + "static/tim_hortons-75a398d2d514a5a9495511284babab16.png";